import { render, staticRenderFns } from "./WebPageLegacy.vue?vue&type=template&id=799e7d16&scoped=true&"
import script from "./WebPageLegacy.vue?vue&type=script&lang=js&"
export * from "./WebPageLegacy.vue?vue&type=script&lang=js&"
import style0 from "./WebPageLegacy.vue?vue&type=style&index=0&id=799e7d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e7d16",
  null
  
)

export default component.exports